<template>
	<div class="about-bg">
		<van-row class="userdata-container">
			<van-col span="24">
				<van-col span="24" class="fix userdata-line userdata-line-image">
					<div class="fl userdata-line-left">头像</div>
					<div class="fr fix">
						<div class="fl">
							<van-uploader v-model="fileList" :max-count="1" :after-read="afterRead">
								<img class="userdata-defaultimg" :src="avatar">
							</van-uploader>
						</div>
						<van-image class="userdata-moreicon" src="../../../static/images/tiaozhuan.png" />
					</div>
				</van-col>
				<van-col span="24" class="userdata-line userdata-line-flex">
					<div class="userdata-line-left">昵称</div>
					<div class="fl">
						<div class="userdata-editarea">
							<van-cell-group>
								<van-field v-model="nickname"	type="textarea"	placeholder="点击编辑" rows="1" autosize />
							</van-cell-group>
						</div>
					</div>
					<van-image class="userdata-moreicon" src="../../../static/images/tiaozhuan.png" />
				</van-col>
				<van-col span="24" class="userdata-line userdata-line-flex">
					<div class="userdata-line-left">签名</div>
					<div class="fl">
						<div class="userdata-editarea">
							<van-cell-group>
								<van-field v-model="bio" type="textarea" placeholder="点击编辑" rows="1" autosize />
							</van-cell-group>
						</div>
					</div>
					<van-image class="userdata-moreicon" src="../../../static/images/tiaozhuan.png" />
				</van-col>
				<van-col span="24" class="userdata-line userdata-line-flex">
					<div class="userdata-line-left">性别</div>
					<div class="fl">
						<div class="userdata-editarea" @click="showPopup">{{gender == 0 ? '女':'男'}}</div>
						<van-popup v-model="isShow" position="bottom" :style="{ width: '89.32vw',height: '35.2vw',margin: '0 5.34vw',bottom: '5.34vw',borderRadius: '2.67vw',background: '#f7f8fa' }">
							<div class="choose-sex">
								<div class="choose-sex-btn" :class="{'sexOn' : gender==1}" @click="selectSex($event)">男</div>
								<div class="choose-sex-btn" :class="{'sexOn' : gender==0}" @click="selectSex($event)">女</div>
							</div>
							<div class="choose-btn" @click="closePopup">取消</div>
						</van-popup>
					</div>
					<van-image class="userdata-moreicon" src="../../../static/images/tiaozhuan.png" />
				</van-col>
				<van-col span="24" class="userdata-line userdata-line-flex">
					<div class="userdata-line-left">手机号</div>
					<div class="fl">
						<div class="userdata-editarea">{{userinfo.mobile}}</div>
					</div>
					<van-image class="userdata-moreicon" src="../../../static/images/tiaozhuan.png" />
				</van-col>
			</van-col>
		</van-row>
		<div class="userdata-btn" @click="update">确定</div>
	</div>
</template>

<script>
	import { Uploader, Popup } from 'vant';
	export default{
		components:{
			[Uploader.name]: Uploader,
			[Popup.name]: Popup
		},
		data(){
			return{
				fileList: [],
				isShow: false,
				userinfo: [],
				nickname: '',
				bio: '',
				gender: '',
				avatar: '' 
			}
		},
		created(){
			let that = this;
			// 百度统计
			let _hmt = _hmt || [];
			(function() {
			  //每次执行前，先移除上次插入的代码
			  document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
			  let hm = document.createElement("script");
			  hm.src = "https://hm.baidu.com/hm.js?5bf14d717bf0afb01060aea203da42c2";
			  hm.id = "baidu_tj";
			  let s = document.getElementsByTagName("script")[0]; 
			  s.parentNode.insertBefore(hm, s);
			})();
			let formdata = new FormData();
			formdata.append('user_id', localStorage.getItem('userId'));
			formdata.append('token', localStorage.getItem('token'));
			that.$axios.post('http://sls.zhishen.net.cn/api/User/getUserInfo', formdata)
			.then(function (res) {
				that.userinfo = res.data.userinfo
				that.nickname = res.data.userinfo.nickname
				that.bio = res.data.userinfo.bio
				that.gender = res.data.userinfo.gender
				that.avatar = res.data.userinfo.avatar
			})
			.catch(function (error) {
				console.log(error);
			});
		},
		methods:{
			afterRead(file) {
				let that = this
				let formdata = new FormData();
				formdata.append('file', file.file);
				formdata.append('user_id', localStorage.getItem('userId'));
				formdata.append('token', localStorage.getItem('token'));
				that.$axios.post('http://sls.zhishen.net.cn/api/Common/upload', formdata)
				.then(function (res) {
					that.avatar = res.data.data.url
				})
				.catch(function (error) {
					console.log(error);
				});
			},
			//点击弹出性别弹框
			showPopup() {
				this.isShow = true;
			},
			//关闭弹框
			closePopup() {
				this.isShow = false;
			},
			//选择性别
			selectSex(event) {	
				let that = this
				if(event.currentTarget.innerHTML == '女'){
					that.gender = 0
				}
				if(event.currentTarget.innerHTML == '男'){
					that.gender = 1
				}
				this.isShow = false
			},
			//修改信息
			update(){
				let that = this
				let formdata = new FormData();
				formdata.append('user_id', localStorage.getItem('userId'));
				formdata.append('token', localStorage.getItem('token'));
				formdata.append('nickname', that.nickname);
				formdata.append('avatar', that.avatar);
				formdata.append('gender', that.gender);
				formdata.append('bio', that.bio);
				that.$axios.post('http://sls.zhishen.net.cn/api/User/updateUserInfo', formdata)
				.then(function (res) {
					if(res.data.code == 1){
						that.$toast({duration: 1000,message: '修改成功'});
						that.$router.push({path: '/personal'});
					}
				})
				.catch(function (error) {
					console.log(error);
				});
			}
		}
	}
</script>

<style>
	@import url("../../assets/css/personal.css");
	.sexOn{color: #ff550a !important;}
</style>



// WEBPACK FOOTER //
// src/view/personal/editdata.vue